import Dispatcher from "Dispatcher";
import TwoPaneMultiSelectTypes
    from "lib/common/twopanemultiselect/data/TwoPaneMultiSelectTypes";

const TwoPaneMultiSelectActions = {
    toggleItem(groupKey, itemKey) {
        Dispatcher.dispatch({
            type: TwoPaneMultiSelectTypes.TOGGLE_ITEM,
            groupKey,
            itemKey,
        });
    },

    populate(groups, selection) {
        Dispatcher.dispatch({
            type: TwoPaneMultiSelectTypes.POPULATE,
            groups,
            selection,
        });
    },

    handleScroll(state) {
        Dispatcher.dispatch({
            ...state,
            type: TwoPaneMultiSelectTypes.HANDLE_SCROLL,
        });
    },

    updatePositions(groups, prevGroups) {
        Dispatcher.dispatch({
            type: TwoPaneMultiSelectTypes.UPDATE_POSITIONS,
            groups,
            prevGroups,
        });
    },
};

export default TwoPaneMultiSelectActions;



// WEBPACK FOOTER //
// ./app/lib/common/twopanemultiselect/data/TwoPaneMultiSelectActions.js